import {useParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {RegionForm} from 'src/pages/Modules/Project/shared/RegionForm';
import {RegionDocumentTitle} from 'src/pages/Modules/Project/shared/regionHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

export const RegionEditPage = () => {
  useSetDocumentTitle(RegionDocumentTitle);
  const {regionId} = useParams();

  return (
    <ContentWrapper>
      {regionId !== undefined && (
        <RegionForm id={Number(regionId)} mode="edit" />
      )}
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ProjectRegionsEdit(':regionId'),
  element: <RegionEditPage />,
  module: ModuleEnum.Projects,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});
